import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { SafeUrl, DomSanitizer } from '@angular/platform-browser';
import { ClientMaster } from '../models/client-master.model';
import { GraphProfile } from '../models/graph-profile.model';
import { AuthProfileResponse } from '../models/auth-data';
import { LOCAL_STORAGE_KEY } from '../../shared/models/constants';

@Injectable({
  providedIn: 'root'
})
export class GlobalService {

  private apiUrl: string = environment.apiUrl + 'api/account/';
  private graphUrl: string = environment.graphUrl;
  private savingsGuideUrl: string = environment.apiUrl + 'api/account/savingsGuide/';
  private userGuideUrl: string = environment.apiUrl + 'api/account/userGuide/';
  private apiSID: string = environment.apiUrl + 'api/salesforce/';

  constructor(
    private http: HttpClient,
    private sanitizer: DomSanitizer) { }

  isAuthorized(): Observable<AuthProfileResponse> {
    const url = this.apiUrl + 'authorized';
    return this.http.get<AuthProfileResponse>(url, { withCredentials: true });
  }

  logout(): Observable<void> {
    const url = this.apiUrl + 'logout';
    const body = {
      dmaToken: localStorage.getItem(LOCAL_STORAGE_KEY.TOKEN),
      msalToken: localStorage.getItem(LOCAL_STORAGE_KEY.MSAL_ID_TOKEN),
      expiresIn: localStorage.getItem(LOCAL_STORAGE_KEY.EXPIRES_IN),
    };
    return this.http.post<void>(url, body);
  }

  getClientMaster(): Observable<ClientMaster> {
    const url = this.apiUrl + 'market-submarket-client';
    return this.http.get<ClientMaster>(url);
  }

  getProfilePhoto(): Observable<SafeUrl> {
    const url = `${this.graphUrl}/photos/48x48/$value`;
    return this.http.get(url, { responseType: 'blob' })
      .pipe(
        catchError(_ => of(null))
      );
  }

  // getProfile(): Observable<GraphProfile> {
  //   const url = `${this.graphUrl}`;
  //   return this.http.get<GraphProfile>(url).pipe(
  //     map((result:any) => this.sanitizer.bypassSecurityTrustUrl(window.URL.createObjectURL(result))),
  //     catchError(_ => of(null))
  //   );
  // }

  getSavingsGuide(): void {
  const url = `${this.savingsGuideUrl}`;
  const fileName = 'DMA_SavingsGuide.xlsx';
  this.http.get(url, { responseType: 'blob' as const })
    .subscribe({
      next: (blob) => {
        if (!(blob instanceof Blob)) return; // guard
        const objectUrl = (window.URL || window.webkitURL).createObjectURL(blob);
        try {
          const a = document.createElement('a');
          a.href = objectUrl;
          a.download = safeFileName(fileName);
          a.rel = 'noopener noreferrer';
          // NOTE: no appendChild — click directly
          a.click();
        } finally {
          (window.URL || window.webkitURL).revokeObjectURL(objectUrl);
        }
      },
      error: () => { /* TODO: handle error UX */ }
    });

  function safeFileName(name: string) {
    return name.replace(/[^\w.\-() ]+/g, '_').slice(0, 200);
  }
}

getUserGuide(): void {
  const url = `${this.userGuideUrl}`;
  const fileName = 'DMA_UserGuide.docx';
  this.http.get(url, { responseType: 'blob' as const })
    .subscribe({
      next: (blob) => {
        if (!(blob instanceof Blob)) return;
        const objectUrl = (window.URL || window.webkitURL).createObjectURL(blob);
        try {
          const a = document.createElement('a');
          a.href = objectUrl;
          a.download = safeFileName(fileName);
          a.rel = 'noopener noreferrer';
          a.click();
        } finally {
          (window.URL || window.webkitURL).revokeObjectURL(objectUrl);
        }
      }
    });

  function safeFileName(name: string) {
    return name.replace(/[^\w.\-() ]+/g, '_').slice(0, 200);
  }
}

  // getSID(): void {
  //     try{
  //       const url = `${this.apiSID}` + 'sidaccounts/';
  //       this.http.get<void>(url).subscribe(response => {
  //           catchError(_ => of(null))
  //       });
  //     }
  //     catch (error) {
  //       process.on('uncaughtException', function(error) {
  //         console.error('an unhandled exception');
  //         //I like using new Error() for my errors (1)
  //         console.error(error instanceof Error ? error.message : error);
  //     });
  //     }
  //   }
}
